/*
 * (c) Copyright, 2023, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useModal } from '~/contexts/ModalContext'
import AddFolderModal from '../addFolderModal/AddFolderModal'

import type { ReactNode } from 'react'

interface AddFolderModalWrapperProps {
  parentFolderId?: string | number
  modalLevelClasses?: string
  children?: ReactNode
}

const AddFolderModalWrapper = (props: AddFolderModalWrapperProps) => {
  const { showModal } = useModal()

  const showAddNewFolderModal = () => {
    showModal(
      <AddFolderModal
        parentFolderId={props.parentFolderId ?? ''}
        modalLevelClasses={props.modalLevelClasses ? { modalClass: props.modalLevelClasses } : undefined}
      />,
      { keepParentModalsOpen: true }
    )
  }

  return (
    <a className="fs12 add-new-folder-link" onClick={showAddNewFolderModal}>
      <span>+</span>
      {props.children ?? null}
    </a>
  )
}

export default AddFolderModalWrapper
